export default function Cellulite() {
  const benefits = [
    {
      icon: "ri-shield-check-line",
      title: "Tratamento Moderno",
      description: "Tecnologias e protocolos de última geração para resultados efetivos e duradouros."
    },
    {
      icon: "ri-user-heart-line",
      title: "Protocolo Personalizado",
      description: "Cada paciente recebe um plano individualizado com base no grau e características da condição."
    },
    {
      icon: "ri-leaf-line",
      title: "Qualidade da Pele",
      description: "Melhora da textura, firmeza e aspecto geral da pele, com resultados visíveis e progressivos."
    }
  ];

  const conditions = [
    { label: "Celulite Grau I ao IV", icon: "ri-focus-3-line" },
    { label: "Flacidez corporal", icon: "ri-body-scan-line" },
    { label: "Qualidade da pele", icon: "ri-sparkling-line" },
    { label: "Lipedema", icon: "ri-heart-pulse-line" }
  ];

  return (
    <section id="celulite" className="bg-white py-20 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Solução Definitiva
          </span>
        </div>

        {/* Main layout */}
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">

          {/* Left — Text */}
          <div className="flex-1">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] leading-tight mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Tratamento avançado<br />
              <span className="italic text-[#C9A84C]">e definitivo para celulite</span>
            </h2>

            <p className="text-[#666] text-sm sm:text-base leading-relaxed mb-5" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              A celulite vai muito além de uma questão estética — ela impacta diretamente a autoestima, o conforto e o bem-estar de milhares de mulheres. Com abordagem médica especializada, os protocolos da Dra. Leonida combinam tecnologia de ponta e planejamento personalizado para resultados reais e sustentáveis.
            </p>

            <p className="text-[#666] text-sm sm:text-base leading-relaxed mb-8" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              O tratamento vai além da superfície: atua na qualidade da pele, na flacidez e no contorno corporal, com rigor técnico e cuidado individualizado em cada etapa do processo.
            </p>

            {/* Conditions chips */}
            <div className="mb-8">
              <p className="text-[#aaa] text-xs uppercase tracking-widest mb-3 font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>Tratamos também</p>
              <div className="flex flex-wrap gap-2">
                {conditions.map((c) => (
                  <div
                    key={c.label}
                    className="flex items-center gap-2 bg-[#faf8f5] border border-[#e8dfc8] rounded-full px-4 py-2 hover:border-[#C9A84C]/60 hover:bg-[#fdf9f0] transition-all duration-300"
                  >
                    <i className={`${c.icon} text-[#C9A84C] text-sm`}></i>
                    <span className="text-[#555] text-xs font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>{c.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Lipedema highlight */}
            <div className="bg-[#faf8f5] border border-[#e8dfc8] rounded-2xl px-6 py-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#C9A84C]/15 flex-shrink-0">
                  <i className="ri-heart-pulse-line text-[#C9A84C] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-[#1a1a1a] text-sm font-semibold mb-1" style={{ fontFamily: 'Playfair Display, serif' }}>Atenção especial ao Lipedema</h4>
                  <p className="text-[#888] text-xs leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                    Condição frequentemente confundida com obesidade ou celulite, o lipedema requer diagnóstico preciso e protocolo próprio. A Dra. Leonida oferece atendimento especializado e humanizado para esse perfil de paciente.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Image + cards */}
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <div className="relative rounded-3xl overflow-hidden mb-5 shadow-lg" style={{ aspectRatio: '3/4' }}>
              <img
                src="/img/celulite.png"
                alt="Tratamento para celulite"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
            </div>

            {/* Benefit cards */}
            <div className="flex flex-col gap-3">
              {benefits.map((b) => (
                <div
                  key={b.title}
                  className="flex items-start gap-4 bg-[#faf8f5] border border-[#e8dfc8] rounded-2xl px-5 py-4 hover:border-[#C9A84C]/50 hover:bg-[#fdf9f0] transition-all duration-300"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#C9A84C]/10 flex-shrink-0">
                    <i className={`${b.icon} text-[#C9A84C] text-base`}></i>
                  </div>
                  <div>
                    <h4 className="text-[#1a1a1a] text-sm font-semibold mb-0.5" style={{ fontFamily: 'Playfair Display, serif' }}>{b.title}</h4>
                    <p className="text-[#999] text-xs leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif' }}>{b.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
